export const TOP_BAR_TAB_ITEMS = [
	{
		title: 'shop',
		icon: 'mdi-view-comfy',
		to: '/store',
		privileges: ['shop-get']
	},
	{
		title: 'admin',
		icon: 'mdi-account-cog-outline',
		to: '/admin',
		privileges: ['admin-get'],
	}
];

export const SIDEBAR_ADMIN_TAB_ITEMS = [
	{
		title: 'pages.pages',
		icon: 'mdi-file-cog',
		active: true,
		items: [
			{
				title: 'pages.home',
				link: '/admin/pages/home',
				icon: 'mdi-numeric-1',
				privileges: ['admin-get']
			},
			{
				title: 'pages.aboutUs',
				link: '/admin/pages/about-us',
				icon: 'mdi-numeric-2',
				privileges: ['admin-get']
			},
			{
				title: 'pages.whyWe',
				link: '/admin/pages/why-we',
				icon: 'mdi-numeric-3',
				privileges: ['admin-get']
			},
			{
				title: 'pages.services',
				link: '/admin/pages/services',
				icon: 'mdi-numeric-4',
				privileges: ['admin-get']
			},
			{
				title: 'pages.contacts',
				link: '/admin/pages/contacts',
				icon: 'mdi-numeric-5',
				privileges: ['admin-get']
			},
			{
				title: 'pages.socialLinks',
				link: '/admin/pages/social-links',
				icon: 'mdi-numeric-6',
				privileges: ['admin-get']
			},
			{
				title: 'pages.portfolio',
				link: '/admin/pages/projects',
				icon: 'mdi-numeric-7',
				privileges: ['admin-get']
			},
			{
				title: 'pages.skills',
				link: '/admin/pages/skills',
				icon: 'mdi-numeric-8',
				privileges: ['admin-get']
			},
			{
				title: 'pages.testimonials',
				link: '/admin/pages/testimonials',
				icon: 'mdi-numeric-9',
				privileges: ['admin-get']
			},
			{
				title: 'pages.funFacts',
				link: '/admin/pages/fun-facts',
				icon: 'mdi-numeric-1',
				extraIcon: 'mdi-numeric-0',
				privileges: ['admin-get']
			},
			{
				title: 'pages.faq',
				link: '/admin/pages/faq',
				icon: 'mdi-numeric-1',
				extraIcon: 'mdi-numeric-1',
				privileges: ['admin-get']
			},
			{
				title: 'pages.team',
				link: '/admin/pages/staff',
				icon: 'mdi-numeric-1',
				extraIcon: 'mdi-numeric-2',
				privileges: ['admin-get']
			},
			{
				title: 'pages.privacyPolicy',
				link: '/admin/pages/privacy-policy',
				icon: 'mdi-numeric-1',
				extraIcon: 'mdi-numeric-3',
				privileges: ['admin-get']
			},
			{
				title: 'pages.publicOffer',
				link: '/admin/pages/public-offer',
				icon: 'mdi-numeric-1',
				extraIcon: 'mdi-numeric-4',
				privileges: ['admin-get']
			}
		]
	},
	{
		title: 'pages.userManagement',
		icon: 'mdi-account-cog',
		active: true,
		items: [
			{
				title: 'pages.userGroups',
				link: '/admin/user-management/user-groups',
				icon: 'mdi-shield-account',
				privileges: ['admin-get']
			},
			{
				title: 'pages.users',
				link: '/admin/user-management/users',
				icon: 'mdi-account-group',
				privileges: ['admin-get']
			}
		]
	},
	{
		title: 'pages.settings',
		icon: 'mdi-cog',
		active: true,
		items: [
			{
				title: 'pages.pricePolicy',
				link: '/admin/settings/price-policy',
				icon: 'mdi-cash-edit',
				privileges: ['admin-get']
			},
			{
				title: 'pages.currencies',
				link: '/admin/settings/currency',
				icon: 'mdi-cash-multiple',
				privileges: ['admin-get']
			}
		]
	}
];

export const SIDEBAR_SHOP_TAB_ITEMS = [
	{
		title: 'shop.orders',
		link: '/store/orders',
		icon: 'mdi-cart',
		privileges: ['shop-get']
	},
	{
		title: 'shop.products',
		link: '/store/products',
		icon: 'mdi-archive',
		privileges: ['shop-get']
	},
	{
		title: 'shop.clients',
		link: '/store/clients',
		icon: 'mdi-account-group',
		privileges: ['shop-get']
	},
	{
		title: 'shop.blog',
		link: '/store/blogs',
		icon: 'mdi-post',
		privileges: ['shop-get']
	},
	{
		title: 'shop.productReviews',
		link: '/store/product-reviews',
		icon: 'mdi-comment-processing',
		privileges: ['shop-get']
	},
	{
		title: 'shop.requests',
		icon: 'mdi-comment-alert',
		active: true,
		items: [
			{
				title: 'shop.tornado',
				link: '/store/requests/tornado',
				icon: 'mdi-information-slab-box',
				privileges: ['shop-get']
			},
			{
				title: 'shop.shop',
				link: '/store/requests/store-tornado',
				icon: 'mdi-store',
				privileges: ['shop-get']
			}
		]
	},
	{
		title: 'shop.settings',
		icon: 'mdi-cog',
		active: true,
		items: [
			{
				title: 'shop.coupons',
				link: '/store/settings/coupons',
				icon: 'mdi-ticket-percent',
				privileges: ['shop-get']
			},
			{
				title: 'shop.branches',
				link: '/store/settings/branches',
				icon: 'mdi-home',
				privileges: ['shop-get']
			},
			{
				title: 'shop.productsCategories',
				link: '/store/settings/product-categories',
				icon: 'mdi-archive-cog',
				privileges: ['shop-get']
			},
			{
				title: 'shop.productsSubcategories',
				link: '/store/settings/product-subcategories',
				icon: 'mdi-archive-cog-outline',
				privileges: ['shop-get']
			},
			{
				title: 'shop.productsBrands',
				link: '/store/settings/product-brands',
				icon: 'mdi-archive-star',
				privileges: ['shop-get']
			}
		]
	}
];
